import { useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import StartPage from "./pages/StartPage/StartPage";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import FormPage from "./pages/FormPage/FormPage";
import TablePage from "./pages/TablePage/TablePage";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import ProtectedRoute from "./middlewares/ProtectedRoute";
import { AuthService } from "./service/auth.service.ts";
import ModulePage from "./pages/ModulePage/ModulePage";
import { fetchTableData } from "./service/table.service.ts";
import { ModulesProvider } from "./context/ModulesContext";
import TablesListPage from "./pages/TablesListPage/TablesListPage.tsx";
import TableDetailPage from "./pages/TableDetailPage/TableDetailPage.tsx";
import { useMenu } from "./context/MenuContext";
import RolesPage from "./pages/RolesPage/RolesPage.tsx";
import RoleEditPage from "./pages/RoleEditPage/RoleEditPage.tsx";
import DiagramEditor from "./pages/DiagramPage/DiagramEditor.tsx";
import ReportPage from "./pages/ReportPage/ReportPage.tsx";
import TranslationsManager from "./pages/TranslationsManager/TranslationsManager.tsx";
import TransactionTemplateEditor from "./pages/TransactionTemplatePage/TransactionTemplateEditor.tsx";
import TransactionPage from "./pages/TransactionPage/TransactionPage.tsx";
import ProcessPage from "./pages/ProcessPage/ProcessPage.tsx";
import StatusPage from "./pages/StatusPage/StatusPage.tsx";
import EventTemplateEditor from "./Templates/EventTemplate/EventTemplateEditor.tsx";
import ProcessActionPage from "./pages/ProcessActionPage/ProcessActionPage.tsx";
import ProcessActionEditor from "./pages/ProcessActionEditorPage/ProcessActionEditor.tsx";
import MenuEditorPage from "./pages/MenuEditorPage/MenuEditorPage.tsx";
import AxiomeBalancePage from "./pages/AxiomeBalancePage/AxiomeBalancePage.tsx";
import DeliveryOperationsPage from "./pages/DeliveryOperationsPage/DeliveryOperationsPage.tsx";
import DeliveryAccessPage from "./pages/DeliveryAccessPage/DeliveryAccessPage.tsx";
import DeliveryExportColumnsPage from "./pages/DeliveryExportColumnsPage/DeliveryExportColumnsPage.tsx";
import AppDownloadsSettingsPage from "./pages/AppDownloadsSettingsPage/AppDownloadsSettingsPage.tsx";
import PayductorPage from "./pages/PayductorPage/PayductorPage.tsx";
import NodeMonitorPage from "./pages/NodeMonitorPage/NodeMonitorPage";

export default function App() {
  const payductorDevEnabled = process.env.REACT_APP_PAYDUCTOR_ENABLED === "true" ||
    window.location.hostname === "admin-dev.smoke.team" ||
    window.location.hostname === "localhost";
  const [isAuthenticated, setIsAuthenticated] = useState(
    AuthService.isAuthenticated(),
  );
  const { loadMenu, menuSettings } = useMenu();

  const handleLogin = async () => {
    await loadMenu();
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    AuthService.logout();
    setIsAuthenticated(false);
  };

  console.log(menuSettings);

  return (
    <Routes>
      <Route path="/" element={<StartPage onLogin={handleLogin} />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Layout isAuthenticated={isAuthenticated} onLogout={handleLogout}>
              <Routes>
                {menuSettings.dashboard &&
                  menuSettings.dashboard.find(
                    (item) => item.key === "dashboard",
                  ) && (
                    <Route
                      path="/dashboard"
                      element={
                        <ModulesProvider>
                          <DashboardPage />
                        </ModulesProvider>
                      }
                    />
                  )}

                <Route path="/form" element={<FormPage />} />

                <Route path="/modules/:id" element={<ModulePage />} />

                <Route
                  path="/table"
                  element={
                    <TablePage
                      fields={["id", "name", "email", "age", "city"].map(
                        (name) => ({ name }),
                      )}
                      tableName="users"
                      loadData={(params) => fetchTableData("users", params)}
                    />
                  }
                />
                <Route path="/tables" element={<TablesListPage />} />
                <Route path="/tables/:id" element={<TableDetailPage />} />

                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/report" element={<ReportPage />} />

                <Route
                  path="/report/:id"
                  element={<ModulePage isReportMode={true} />}
                />

                <Route path="/roles" element={<RolesPage />} />
                <Route path="/roles/:id/edit" element={<RoleEditPage />} />

                <Route path="/diagrams" element={<DiagramEditor />} />

                <Route path="/translations" element={<TranslationsManager />} />

                <Route
                  path="/transaction-template"
                  element={<TransactionTemplateEditor />}
                />
                <Route
                  path="/transaction-template/:transactionId"
                  element={<TransactionTemplateEditor />}
                />
                {/* <Route
                  path="/transactions/view"
                  element={<TransactionPage />}
                /> */}

                <Route
                  path="/event-template"
                  element={<EventTemplateEditor />}
                />
                <Route path="/process-view" element={<ProcessPage />} />

                <Route path="/processes" element={<ProcessPage />} />
                <Route path="/system-status" element={<StatusPage />} />
                <Route path="/node-monitor" element={<NodeMonitorPage />} />
                <Route path="/axiome-balance" element={<AxiomeBalancePage />} />
                <Route
                  path="/delivery-operations"
                  element={<DeliveryOperationsPage />}
                />
                <Route
                  path="/delivery-access"
                  element={<DeliveryAccessPage />}
                />
                <Route
                  path="/delivery-export-columns"
                  element={<DeliveryExportColumnsPage />}
                />
                <Route
                  path="/app-downloads-settings"
                  element={<AppDownloadsSettingsPage />}
                />
                {payductorDevEnabled && <Route path="/payductor/methods" element={<PayductorPage section="methods" />} />}
                {payductorDevEnabled && <Route path="/payductor/credentials" element={<PayductorPage section="credentials" />} />}
                {payductorDevEnabled && <Route path="/payductor/checkout" element={<PayductorPage section="checkout" />} />}
                {payductorDevEnabled && <Route path="/payductor/rates" element={<PayductorPage section="rates" />} />}
                {payductorDevEnabled && <Route path="/payductor/payments" element={<PayductorPage section="payments" />} />}
                <Route
                  path="/process-action/:id"
                  element={<ProcessActionPage />}
                />

                <Route
                  path="/process-action-editor/:processId/:actionId"
                  element={<ProcessActionEditor />}
                />

                <Route path="/menu-editor" element={<MenuEditorPage />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
